import styled from 'styled-components';

export const BoardContainer = styled.div`
  display: grid;
  grid-auto-columns: minmax(260px, 1fr);
  grid-auto-flow: column;
  gap: ${({ theme }) => theme.spacing[4]};
  overflow-x: auto;
  padding-bottom: ${({ theme }) => theme.spacing[2]};
  min-height: 400px;
`;

export const Column = styled.div`
  background: ${({ theme }) => theme.colors.gray50};
  border-radius: ${({ theme }) => theme.radii.xl};
  display: flex;
  flex-direction: column;
  min-height: 200px;
  border: 1px solid ${({ theme }) => theme.colors.gray200};
`;

export const ColumnHeader = styled.div<{ $color: string }>`
  padding: ${({ theme }) => `${theme.spacing[3]} ${theme.spacing[4]}`};
  border-top: 3px solid ${(p) => p.$color};
  border-radius: ${({ theme }) => theme.radii.xl} ${({ theme }) => theme.radii.xl} 0 0;
  font-family: ${({ theme }) => theme.fonts.heading};
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  font-size: ${({ theme }) => theme.fontSizes.base};
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

export const ColumnBody = styled.div`
  padding: ${({ theme }) => theme.spacing[3]};
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[2]};
`;

export const Card = styled.div<{ $borderColor: string }>`
  background: ${({ theme }) => theme.colors.bgSurface};
  border-radius: ${({ theme }) => theme.radii.lg};
  padding: ${({ theme }) => theme.spacing[3]};
  border-left: 3px solid ${(p) => p.$borderColor};
  box-shadow: ${({ theme }) => theme.shadows.xs};
  cursor: pointer;
  transition: transform ${({ theme }) => theme.transitions.fast}, box-shadow ${({ theme }) => theme.transitions.fast};

  &:hover {
    transform: translateY(-2px);
    box-shadow: ${({ theme }) => theme.shadows.md};
  }
`;

export const CardCourt = styled.div`
  font-size: 0.8rem;
  color: ${({ theme }) => theme.colors.gray500};
  margin-bottom: ${({ theme }) => theme.spacing[1]};
`;

export const CardStatusBadge = styled.span`
  font-size: 0.7rem;
`;

export const CardSignature = styled.div`
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  margin-bottom: ${({ theme }) => theme.spacing[1]};
  color: ${({ theme }) => theme.colors.textPrimary};
`;

export const CardMeta = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.xs};
  color: ${({ theme }) => theme.colors.textMuted};
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing[2]};
`;

export const StatusSelect = styled.div`
  margin-top: ${({ theme }) => theme.spacing[2]};

  .form-select-sm {
    font-size: 0.75rem;
  }
`;

export const EmptyColumn = styled.div`
  padding: ${({ theme }) => `${theme.spacing[6]} ${theme.spacing[4]}`};
  text-align: center;
  color: ${({ theme }) => theme.colors.gray400};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  border: 2px dashed ${({ theme }) => theme.colors.gray200};
  border-radius: ${({ theme }) => theme.radii.lg};
  margin: ${({ theme }) => theme.spacing[2]};
`;
